var exports = {
  "lG": "Dialog__y7IF-J",
  "az": "Box__bTSf2r",
  "wy": "Box_1__EBLmRj",
  "EY": "Text__8x7KnM",
  "UE": "Text_1__7RnYDd",
  "Nl": "Text_2__KM-i_P",
  "UZ": "Text_3__Qce6Pp",
  "Hx": "Flash__KARNCU",
  "pv": "Box_2__-egJbq",
  "w9": "Box_3__E4W_vP",
  "pQ": "Box_4__iOoTI-",
  "ws": "Box_5__fxpEHg",
  "K0": "IconButton__flMJmE",
  "D6": "Box_6__m5xwDP",
  "m4": "Octicon__4tgR97",
  "KI": "Box_7__vVvDb2",
  "N8": "Text_4__b3ty2h",
  "pm": "Box_8__nZIocb",
  "w0": "Box_9__cpFT3w",
  "UK": "Text_5__J_vURs",
  "Oh": "Box_10__tfIKgC",
  "HF": "Box_11__DAqF57",
  "zM": "Text_6__KlGzm9",
  "ay": "Box_12__zs5hFs",
  "VV": "Box_13__bGn5u0",
  "Go": "Text_7__Q-BUv1",
  "On": "Box_14__IrGwmF",
  "VG": "Box_15__I9urw_",
  "OY": "Box_16__VJatxV",
  "QH": "Octicon_1__2I8fSI",
  "JK": "Octicon_2__uCub-p",
  "pl": "Octicon_Skipped__aew-ou",
  "N_": "Link__Aaza5D",
  "JU": "Label__PzGIrw",
  "Ob": "Ruleset_Text_Fail__XRZTyl",
  "ZO": "Ruleset_Text_Skip__ncmL1l",
  "Hk": "Box_17__f4FKym",
  "AO": "Box_18__c0QHFz",
  "G$": "Text_9__egR1R3",
  "VM": "Box_19__6qjnxm",
  "Wi": "IconButton_1__mIIdFy",
  "j1": "Box_20__djwwW-",
  "qD": "Box_21__O49FEf",
  "xf": "Box_22__6gfmvY",
  "Rp": "RunMeta__46WV8Y",
  "Cr": "Octicon_3__79ojR8",
  "Bv": "Octicon_Skipped_RuleRun__MdY6a0",
  "vu": "Octicon_4__zHXHv2",
  "I_": "Text_10__QLIsRl",
  "Bw": "Text_11__s8f2zO",
  "dw": "Duration__6z416K",
  "h_": "DurationInfoButton__tXKWnX",
  "WN": "SuiteTimings__lH91In",
  "Hp": "SuiteTiming__0u7O1W",
  "Pp": "SuiteTimingLabel__GDbhHw",
  "Cj": "SuiteTimingValue__jY7Y5W",
  "xQ": "SuiteTimingNote__qMGtAU",
  "ET": "Box_23__gzYCuv",
};

module.exports = exports;
